import type { ComponentPropsWithRef } from 'react'
import { useId } from 'react'

export interface CheckboxInputProps extends Omit<
    ComponentPropsWithRef<'input'>,
    'type' | 'checked'
> {
    label: string
    defaultChecked?: boolean
    useBookingFormThemeCssVariables?: boolean
}

export function CheckboxInput({
    label,
    id,
    disabled = false,
    useBookingFormThemeCssVariables = false,
    className = '',
    style,
    defaultChecked,
    ...inputProps
}: CheckboxInputProps) {
    const generatedId = useId()
    const inputId = id ?? generatedId

    const themeClassName = useBookingFormThemeCssVariables
        ? 'text-booking-form-theme-main-background-color focus:ring-booking-form-theme-main-background-color focus-visible:ring-booking-form-theme-main-background-color'
        : 'text-primary focus:ring-primary focus-visible:ring-primary'

    return (
        <div className="flex items-center gap-x-2">
            <input
                {...inputProps}
                id={inputId}
                type="checkbox"
                defaultChecked={defaultChecked}
                disabled={disabled}
                style={{
                    height: '1.4rem',
                    width: '1.4rem',
                    verticalAlign: 'middle',
                    ...style,
                }}
                className={`peer rounded-md border border-gray-400 ${themeClassName} focus:ring-2 focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:border-stone-300 disabled:bg-stone-100 disabled:text-gray-400 disabled:checked:bg-gray-400 disabled:checked:border-gray-400 disabled:checked:hover:bg-gray-400 disabled:hover:bg-stone-100 disabled:hover:border-stone-300 disabled:select-none cursor-pointer ${className}`.trim()}
            />
            <label
                htmlFor={inputId}
                className={`text-gray-800 select-none ${disabled ? 'text-gray-400 cursor-not-allowed' : 'cursor-pointer'}`.trim()}
            >
                {label}
            </label>
        </div>
    )
}
